import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import classNames from "classnames";

/**
 * PropertyUseSelect — Syncfusion DropDownList pre-wired to the propertyUses Redux store.
 *
 * Decorated replacement for the legacy react-select `PropertyUseSelectBox`.
 * Emits the selected `parameterId` via `onChange`.
 */
export default function PropertyUseSelect({
  placeholder = "Loan Purpose *",
  value,
  onChange,
  error,
  disabled = false,
  className,
  floatLabelType = "Auto",
  ...props
}) {
  const { propertyUses: records } = useSelector(state => state.propertyUses);

  const dataSource = useMemo(() => {
    if (!records?.length) return [];
    return records.map(pu => ({ text: pu.name, value: pu.parameterId }));
  }, [records]);

  const handleChange = useCallback(
    e => onChange?.(e.itemData?.value ?? undefined),
    [onChange],
  );

  return (
    <div className={classNames("select-input-wrapper", className)}>
      <DropDownListComponent
        placeholder={placeholder}
        floatLabelType={floatLabelType}
        dataSource={dataSource}
        fields={{ text: "text", value: "value" }}
        value={value}
        change={handleChange}
        enabled={!disabled}
        cssClass={classNames("e-outline", { "e-error": !!error })}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}

PropertyUseSelect.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  floatLabelType: PropTypes.oneOf(["Auto", "Always", "Never"]),
};

